import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { AuthGuard } from '../core/guards/auth.guard';
import { LogGridComponent } from './components/log-view/log-grid/log-grid.component';
import { UsersComponent } from './components/users/users.component';
import { AdminConfigComponent } from './components/admin-config/admin-config.component';


const routes: Routes =
  [
    {
      path: '',
      component: AdminComponent,
      canActivateChild: [AuthGuard],
      data: { breadcrumb: 'Admin', claim: 'ADM' },
      children:
        [
          {
            path: 'log',
            component: LogGridComponent,
            data: { breadcrumb: 'Log', claim: 'ADM' }
          },
          {
            path: 'users',
            component: UsersComponent,
            data: { breadcrumb: 'Users', claim: 'ADM' }
          },
          {
            path: 'admin-configuration',
            component: AdminConfigComponent,
            data: { breadcrumb: 'Admin configuration', claim: 'ADM' }
          },
        ]
    }

  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
